/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
// file unit test nya mana
@Injectable({
  providedIn: 'root'
})
export class FooterService {
  private showLang: BehaviorSubject<any> = new BehaviorSubject<any>({
    en: true,
    id: true
  });


  public setLang(data: any) {
    return this.showLang.next(data);
  }

  public getLang() {
    return this.showLang.asObservable();
  }
}
